import { isArray, isFunction, isObject } from "./is.mjs";
import { isDefined } from "./guards.mjs";
export function clearUndefined(objectOrArray, checkDefineFn = (value) => value !== void 0) {
  if (isArray(objectOrArray)) {
    return objectOrArray.map((value) => clearUndefined(value, checkDefineFn)).filter(checkDefineFn);
  }
  if (isObject(objectOrArray)) {
    return Object.fromEntries(Object.entries(objectOrArray).map((value) => clearUndefined(value, checkDefineFn)).filter(([_, value]) => clearUndefined(value, checkDefineFn)));
  }
  return objectOrArray;
}
export const nilDefault = (value, defaultValue) => {
  return isDefined(value) ? value : defaultValue;
};
export const cloneDeep = (value) => {
  return JSON.parse(JSON.stringify(value));
};
export const sleep = (timeout) => {
  return new Promise((resolve) => setTimeout(resolve, timeout));
};
export const toFunction = (callback) => {
  return isFunction(callback) ? callback : () => callback;
};
